import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";
import { fetchApi } from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";

export const mapToDemandOutFormat = mapDictionaryState;

const demandOutFormatApi = createDictionaryApiFactory("demandOutFormat");

export const getDemandOutFormat = demandOutFormatApi.search;

export const getDemandOutFormatSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/demandOutFormat/select`) as SelectItemDto[];
    return response;
};
